const EVENTS = {
  SIGN_UP: {
    PROFESSIONAL_PAUSE: {
      SURVEY_SUBMITTED: 'Sign Up - Professional Pause Survey Submitted',
    },
  },
  DASHBOARD: {
    LEFT_NAV: {
      DASHBOARD_CLICKED: 'Dashboard - Dashboard Clicked',
      MY_PROJECTS_CLICKED: 'Dashboard - My Projects Clicked',
      FIND_PROJECTS_CLICKED: 'Dashboard - Search Projects Clicked',
      COMMUNITY_CLICKED: 'Dashboard - Community Clicked',
      BROWSE_ORGANIZATIONS_CLICKED: 'Dashboard - Browse Organizations Clicked',
      EVENTS_CLICKED: 'Dashboard - Events Clicked',
      ENGAGE_IN_COMMUNITY_CLICKED: 'Dashboard - Engage in Community Clicked',
      LEARNING_CLICKED: 'Dashboard - Learning Clicked',
      RESOURCES_CLICKED: 'Dashboard - Resources Clicked',
      FAQ_CLICKED: 'Dashboard - FAQ Clicked',
      ASK_US_A_QUESTION_CLICKED: 'Dashboard - Ask Us A Question Clicked',
      CORPORATE_CONNECTIONS_CLICKED: 'Dashboard - Corporate Connections Clicked',
      CREATE_PROJECT_CLICKED: 'Dashboard - Create Project Clicked',
      FIND_PROFESSIONALS_CLICKED: 'Dashboard - Find Professionals Clicked',
      SCALE_UP_TOOLKIT_CLICKED: 'Dashboard - Scale Up Toolkit Clicked',
      MY_COHORT_CLICKED: 'Dashboard - My Cohort Clicked',
    },
    ORG_DROPDOWN: {
      EDIT_PROFILE_CLICKED: 'Dashboard - Edit Profile Clicked',
      PREVIEW_PROFILE_CLICKED: 'Dashboard - Preview Profile Clicked',
      INVITE_TEAM_MEMBER_CLICKED: 'Dashboard - Invite Team Member Clicked',
    },
    PROFILE_DROPDOWN: {
      HOME_CLICKED: 'Dashboard - Home Clicked',
      INBOX_CLICKED: 'Dashboard - Inbox Clicked',
      ACCOUNT_AND_PROFILE_CLICKED: 'Dashboard - Account and Profile Clicked',
      LOGOUT_CLICKED: 'Dashboard - Logout Clicked',
    },
    HOME: {
      // Change status
      CHANGE_YOUR_STATUS_CLICKED: 'Dashboard - Change Your Status Clicked',
      SEARCH_STATUS_MODAL_CANCELLED: 'Dashboard - Search Status Modal Cancelled',
      SEARCH_STATUS_MODAL_CONFIRMED: 'Dashboard - Search Status Modal Confirmed',
      // NBAs
      NBA_DISMISSED: 'Dashboard - NBA Dismiss Clicked',
      NBA_DISMISS_MODAL_CANCELLED: 'Dashboard - NBA Dismiss Modal Cancelled',
      NBA_DISMISS_MODAL_CONFIRMED: 'Dashboard - NBA Dismiss Modal Confirmed',
      NBA_LINK_CLICKED: 'Dashboard - NBA Link Clicked',
      NBA_DISMISSED_VIA_INTRO_VIDEO: 'Dashboard - NBA Dismissed Via Intro Video',
      // Activity Articles
      ACTIVITY_ARTICLE_LINK_CLICKED: 'Dashboard - Activity Article Link Clicked',
    },
  },
} as const;

export default EVENTS;
